export default "__VITE_ASSET__DUrPTn95__"